import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 320px;
  background: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 32px;
`;

export const LoaderWrapper = styled.div`
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: center;
`;

type ImageProps = {
  src?: string;
};

export const Image = styled.div<ImageProps>`
  width: 100%;
  aspect-ratio: 16 / 9;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: ${props => (props.src ? `url(${props.src})` : 'none')};
`;
